import clsx from "clsx";
import { FC } from "react";

import { Icon } from "@tsmono/react/icons";
import { isRecord } from "@tsmono/util";

import styles from "./ValidationResult.module.css";

interface ValidationResultProps {
  result: boolean | Record<string, boolean>;
  target?: unknown;
  label?: string;
}

export const ValidationResult: FC<ValidationResultProps> = ({
  result,
  target,
  label,
}) => {
  if (typeof result === "boolean") {
    return (
      <Result
        value={result}
        targetValue={valueStr(resolveTargetValue(target, label))}
      />
    );
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  } else if (result !== null && typeof result === "object") {
    const entries = Object.entries(result);

    return (
      <div className={clsx(styles.validationTable)}>
        {entries.map(([key, value]) => (
          <div key={`validation-result-${key}`}>
            <Result
              value={value}
              targetValue={valueStr(resolveTargetValue(target, key))}
            />
          </div>
        ))}
      </div>
    );
  }
};

const Result: FC<{ value: boolean; targetValue?: string }> = ({
  value,
  targetValue,
}) => {
  return (
    <div>
      <div className={clsx(value ? styles.true : styles.false, styles.result)}>
        <Icon name={value ? "confirm" : "close"} />
      </div>
      <span
        className={clsx(
          styles.targetValue,
          "text-size-smallestest",
          "text-style-secondary"
        )}
        title={targetValue}
      >
        {targetValue}
      </span>
    </div>
  );
};

const resolveTargetValue = (target: unknown, key?: string): unknown => {
  if (target === undefined) {
    return "";
  }

  if (key === undefined) {
    return target;
  }

  if (isRecord(target)) {
    return target[key] ?? false;
  }
  return target;
};

const valueStr = (target: unknown): string => {
  if (target === null) {
    return "null";
  } else if (typeof target === "string") {
    return target;
  } else if (typeof target === "number" || typeof target === "boolean") {
    return target.toString();
  } else if (Array.isArray(target)) {
    return `[Array(${target.length})]`;
  } else if (typeof target === "object") {
    return "{Object}";
  } else {
    return "undefined";
  }
};
